import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductAttribute } from '../data/product';

export type ProductAttributeCreate = Omit<
  ProductAttribute,
  'productAttributeId' | 'tenantId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy' | 'deletedAt' | 'deletedBy'
>;
export type ProductAttributeFilter = Partial<
  Pick<ProductAttribute, 'productAttributeId' | 'productId' | 'storeId' | 'attributeId' | 'attributeValueId'>
>;

export function createProductAttributeService(client: AxiosInstance) {
  return createCrudService<ProductAttribute, ProductAttributeCreate, ProductAttributeFilter>(
    client,
    '/ProductAttribute',
    'productAttributeId'
  );
}

export type ProductAttributeService = CrudService<
  ProductAttribute,
  ProductAttributeCreate,
  ProductAttributeFilter
>;
